import React from 'react';

export type CircularProgressProps = {
  size?: number;
  strokeWidth?: number;
  color?: string;
  variant?: 'determinate' | 'indeterminate';
  value?: number;
};

const CircularProgress: React.FC<CircularProgressProps> = ({
  size = 48,
  strokeWidth = 4,
  color = 'text-mint-500',
  variant = 'indeterminate',
  value = 0,
}) => {
  const progress = Math.min(Math.max(value, 0), 100);
  const circumference = 2 * Math.PI * 20.2;
  const offset = ((100 - progress) / 100) * circumference;

  return (
    <div
      className={`relative inline-block`}
      style={{width: size, height: size}}
    >
      <svg
        className={
          variant === 'indeterminate' ? `animate-spin ${color}` : color
        }
        viewBox="22 22 44 44"
        style={{width: size, height: size}}
      >
        <circle
          className="opacity-25 stroke-current"
          cx="44"
          cy="44"
          r="20.2"
          fill="none"
          strokeWidth={strokeWidth}
        />
        <circle
          className="stroke-current"
          cx="44"
          cy="44"
          r="20.2"
          fill="none"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={variant === 'determinate' ? offset : '60'}
          transform="rotate(-90 44 44)" // Rotate the circle to start from the top
        />
      </svg>
    </div>
  );
};

export default CircularProgress;
